import { updateMe, getMe, changePassword } from "store/services/me.services";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";
import { uploadFile } from "store/services/utilities";

export const GetMeAction = createAsyncThunk(
  "me/getMe",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await getMe(payload);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(response);
      }
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateMeAction = createAsyncThunk(
  "me/updateMe",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { file, onSuccess, onError, ...rest } = payload;
    try {
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: file,
          uploadFor: "profile",
        });

        if (uploadFilesResponse.status === 0) {
          dispatch(
            openToast({ type: "error", message: uploadFilesResponse?.message }),
          );
          return rejectWithValue(uploadFilesResponse);
        }
        rest.imageName = uploadFilesResponse.response[0].url ?? "";
      }
      const response = await updateMe(rest);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) onSuccess();
        return fulfillWithValue(response);
      }
      if (onError) onError();
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const ChangePasswordAction = createAsyncThunk(
  "me/changePasswordAction",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await changePassword(payload);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );

      return rejectWithValue(error);
    }
  },
);
